import { LayoutPage } from '@/components/hoc';
import { TBreadcrumbProps } from '@/types';
import { UsersRound } from 'lucide-react';
import { BodyPage } from './components';
import { useUser } from './hooks';
import routes from '@/lib/routes';

const UserSubAccountsPage = () => {

	const { userData } = useUser();

	const breadcrumb = (
		userData?.username
			? ({
				title: 'Sous comptes',
				subMenus: [
					{
						tooltip: 'Liste des utilisateurs',
						href: routes.nav.users.getHref(),
						title: 'Utilisateurs'
					},
					{
						href: routes.nav.users.single.getHref(userData._id),
						tooltip: userData.username,
						title: userData.username
					}
				]
			}) as TBreadcrumbProps
			: undefined
	);

	return (
		<LayoutPage
			breadcrumb={breadcrumb} 
			icon={UsersRound}>
			<BodyPage />
		</LayoutPage>
	);

};

export default UserSubAccountsPage;
